<template>
  <b-row>
    <b-col cols="12">
      <b-alert show>
        <div class="d-flex align-items-center">
          <i class="fas fa-exclamation-triangle mr-3"></i> Selecione abaixo os
          produtos da Totvs que deseja importar para a Constr Up ou importe
          todos de uma vez.
        </div>
        <div>
          <br />
          <b>ATENÇÃO:</b> O critério para verificar se um produto já foi
          importado para Constr Up é o <b>código de barras</b> do
          produto.
        </div>
      </b-alert>
      <div class="mt-2">
        <b-input
          placeholder="Pesquise pelo id dos produtos no TotvsWinthor"
          debounce="1000"
          class="mb-1"
          type="number"
          v-model="searchFields.productName"
          :disabled="loadingProducts"
          @change="listProducts"
          @keypress.enter="listProducts"
          
        />
        <b-checkbox
          :disabled="loadingProducts"
          v-model="searchFields.onlyNotIntegrated"
          @change="listProducts"
        >
          Somente não integrados
        </b-checkbox>
      </div>
      <div class="mt-4 d-flex align-items-center" style="gap: 1rem">
        <b-dropdown
          left
          variant="outline-success"
          html="
            <i class='fas fa-file-import mr-2'></i> Integrar
          "
          :disabled="loadingProducts"
        >
          <b-dropdown-item @click="integrateSelectedProducts"
            >Integrar apenas selecionados</b-dropdown-item
          >
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item
            variant="warning"
            @click="integrateAllProducts"
            disabled
          >
            <i class="fas fa-exclamation-triangle mr-2"></i>Integrar todos
            <b-badge class="ml-1" variant="warning">Em breve</b-badge>
          </b-dropdown-item>
        </b-dropdown>
        <b-button
          :disabled="loadingProducts"
          variant="warning"
          @click="
            selectedItems.length
              ? $refs.TotvsWinthorProductsTable.clearSelected()
              : $refs.TotvsWinthorProductsTable.selectAllRows()
          "
        >
          <div v-if="selectedItems.length">
            <i class="fas fa-minus-circle mr-2"></i>Desselecionar todos
          </div>
          <div v-else>
            <i class="fas fa-check-double mr-2"></i>Selecionar todos
          </div>
        </b-button>
        <div class="ml-auto">
          {{ selectedItems.length }} produto(s) selecionado(s)
        </div>
      </div>
    </b-col>
    <b-col cols="12" class="mt-5 mb-5 h-100">
      <b-table
        hover
        striped
        bordered
        selectable
        show-empty
        sticky-header="800px"
        select-mode="multi"
        ref="TotvsWinthorProductsTable"
        empty-text="Não há produtos a serem integrados a Constr Up"
        :busy="loadingProducts"
        :fields="table.headers"
        :items="table.items"
        @row-selected="onRowSelected"
      >
        <template #cell(selected)="{ rowSelected, index }">
          <b-form-checkbox
            :checked="rowSelected"
            @change="
              rowSelected
                ? $refs.TotvsWinthorProductsTable.unselectRow(index)
                : $refs.TotvsWinthorProductsTable.selectRow(index)
            "
          >
          </b-form-checkbox>
        </template>

      </b-table>
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="totalRows"
        :per-page="pagination.itemsPerPage"
        :disabled="loadingProducts"
        align="center"
        pills
      ></b-pagination>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex';

import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import makeToast from '@/mixins/makeToast';
import IntegrationTypes from 'Enums/Integration/IntegrationTypes';
import { buildRequiredIntegrationQueryParams } from '@/utils/integration';

export default {
  name: 'IntegrateTotvsWinthorProducts',
  mixins: [makeToast],
  props: {},
  computed: {
    ...mapState(['dadosUsuario']),
    reachLastPage() {
      if (this.pagination.total < this.pagination.itemsPerPage) return true;

      return false;
    },

    totalRows() {
      if (this.pagination.currentPage === 1) {
        return this.reachLastPage
          ? this.pagination.itemsPerPage
          : this.pagination.itemsPerPage + 1;
      }

      if (this.reachLastPage) {
        return this.pagination.itemsPerPage * this.pagination.currentPage;
      }

      return this.pagination.itemsPerPage * this.pagination.currentPage + 1;
    },
    shouldGoToNextPage() {
      return this.pagination.total >= this.pagination.itemsPerPage;
    },
  },
  data() {
    return {
      loadingProducts: false,
      searchFields: {
        productName: '',
        onlyNotIntegrated: true,
      },
      selectedItems: [],
      table: {
        headers: [
          {
            key: 'selected',
            label: '',
            tdClass: 'text-center',
            thStyle: {
              width: '50px',
              textAlign: 'center',
            },
          },
          {
            key: 'id',
            label: 'Id Prod.',
          },
          {
            key: 'name',
            label: 'Nome',
          },
          {
            key: 'barCode',
            label: 'Código de Barras',
          },
          {
            key: 'isActive',
            label: 'Ativo',
            formatter(value, key, item) {
              return item.isActive ? 'Sim' : 'Não';
            },
          },
          {
            key: 'isVisible',
            label: 'Visivél',
            formatter(value, key, item) {
              return item.isVisible ? 'Sim' : 'Não';
            },
          },
        ],
        items: [],
      },
      pagination: {
        currentPage: 1,
        itemsPerPage: 100,
        total: 0,
        lastPage: 0,
      },
    };
  },
  watch: {
    'searchFields.productName': function () {
      this.pagination = {
        currentPage: 1,
        itemsPerPage: 100,
        total: 0,
        lastPage: 0,
      };
      this.listProducts();
    },
    'searchFields.onlyNotIntegrated': function () {
      this.pagination = {
        currentPage: 1,
        itemsPerPage: 100,
        total: 0,
        lastPage: 0,
      };
      this.listProducts();
    },
    'pagination.currentPage': function () {
      this.listProducts();
    },
  },
  mounted() {
    this.listProducts();
  },
  methods: {
    async listProducts() {
      if (this.loadingProducts) return;

      this.loadingProducts = true;
      this.$set(this, 'selectedItems', []);

      const requiredParams = buildRequiredIntegrationQueryParams(
        this.dadosUsuario.id,
        IntegrationTypes.TOTVS_WINTHOR
      );

      const params = new URLSearchParams(requiredParams);
      params.append('pagina', this.pagination.currentPage);
      params.append('limite', this.pagination.itemsPerPage);
      params.append('nome', this.searchFields.productName);
      params.append('apenasNaoImportados', this.searchFields.onlyNotIntegrated);

      try {
        const { data } = await shopkeeperAppApi.get(
          `/integration/erp/products?${params.toString()}`
        );

        this.table.items = data.data.items || [];
        this.pagination.total = data.data.originalCount;
      } catch {
        this.makeToast(
          'Erro',
          `Houve um ao buscar os produtos na Totvs, confirme se sua integração está ativa`,
          'danger'
        );
      } finally {
        this.loadingProducts = false;
      }
    },
    async integrateSelectedProducts() {
      if (this.loadingProducts) return;

      this.loadingProducts = true;

      try {
        const requiredParams = buildRequiredIntegrationQueryParams(
          this.dadosUsuario.id,
          IntegrationTypes.TOTVS_WINTHOR
        );

        const selectedProducts = this.selectedItems.map((item) => item.id);

        if (!selectedProducts.length) {
          this.makeToast(
            'Erro',
            'Selecione ao menos um produto para integrar',
            'warning'
          );
          return;
        }

        await shopkeeperAppApi.post(
          `/integration/erp/integrate/products?${requiredParams.toString()}`,
          {
            productsIds: selectedProducts,
          }
        );

        this.makeToast(
          'Sucesso',
          `Os ${selectedProducts.length} produtos foram adicionados a fila de integração com sucesso. O processo pode demorar alguns minutos`,
          'success'
        );

        this.selectedItems.forEach((item) => {
          const index = this.table.items.findIndex((p) => p.id === item.id);
          this.$refs.TotvsWinthorProductsTable.unselectRow(index);
        });

        this.$set(this, 'selectedItems', []);

        this.$set(
          this.table,
          'items',
          this.table.items.filter((item) => !selectedProducts.includes(item.id))
        );

        if (!this.table.items.length && this.shouldGoToNextPage)
          this.pagination.currentPage++;
      } catch {
        this.makeToast(
          'Erro',
          `Houve um ao integrar os produtos na Totvs, confirme se sua integração está ativa`,
          'danger'
        );
      } finally {
        this.loadingProducts = false;
      }
    },
    async integrateAllProducts() {
      if (this.loadingProducts) return;

      this.loadingProducts = true;

      try {
        const requiredParams = buildRequiredIntegrationQueryParams(
          this.dadosUsuario.id,
          IntegrationTypes.TOTVS_WINTHOR
        );

        await shopkeeperAppApi.post(
          `/integration/erp/integrate/all-products?${requiredParams.toString()}`
        );

        this.makeToast(
          'Sucesso',
          'Os produtos foram adicionados a fila de integração com sucesso. O processo pode demorar alguns minutos',
          'success'
        );
        this.$refs.TotvsWinthorProductsTable.clearSelected();
        this.table.items = [];
      } catch {
        this.makeToast(
          'Erro',
          `Houve um ao integrar os produtos na Totvs, confirme se sua integração está ativa`,
          'danger'
        );
      } finally {
        this.loadingProducts = false;
      }
    },
    onRowSelected(selectedItems) {
      this.$set(this, 'selectedItems', selectedItems || []);
    },
  },
};
</script>
